import Laravel from "../../../common/technologies/laravel";
import Sendgrid from "../../../common/technologies/sendgrid";
import Redis from "../../../common/technologies/redis";
import Docker from "../../../common/technologies/docker";
import MongoDb from "../../../common/technologies/mongodb";
import MySQL from "../../../common/technologies/mysql";

function Luc() {
  return (
    <div className={'portfolio-modal'}>
      <h1>LUC</h1>
      <h4>Overview</h4>
      <p>
        This system allows users to play baccarat (This system and the DBAC system is related), just like other baccarat website, this system will have multiple tables, users can enter one table and play.
      </p>
      <h4>The difficult parts</h4>
      <ul>
        <li>Handle concurrent calls when user click bet too fast.</li>
        <li>Working with large data (in relational database)</li>
      </ul>
      <h4>My roles and responsibilities</h4>
      <ul>
        <li>Responsible for betting logic</li>
        <li>Read requirements, analyse, design database for new features</li>
      </ul>
      <h4>Technologies used</h4>
      <div className={'project-technologies'}>
        <Laravel />
        <Sendgrid />
        <Redis />
        <Docker />
        <MongoDb />
        <MySQL />
      </div>
      <h4>What I learnt from this project</h4>
      <ul>
        <li>Handling concurrent call.</li>
        <li>Learn about ACID in mysql to increase accountability for the system.</li>
      </ul>
    </div>
  )
}

export default Luc;
